import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DndDirective } from './directives/dnd.directive';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { DateFilterPipe } from './pipes/date.pipe';
import { SumPipe } from './pipes/sum.pipe';
import { AveragePipe } from './pipes/average.pipe';

@NgModule({
  declarations: [DndDirective, PhoneNumberPipe, FilterPipe, DateFilterPipe, SumPipe, AveragePipe ],
  imports: [
    CommonModule
  ],
  exports: [DndDirective, PhoneNumberPipe, FilterPipe, DateFilterPipe, SumPipe, AveragePipe]
})
export class CoreModule { }
